import { Box, Typography } from "@mui/material";
import React from "react";
import { useState } from "react";
import AddUserIcon from "../../assets/SVG/addUserIcon";
import PillIcon from "../../assets/SVG/pillIcon";
import DetailsDrug from "../../components/leaderGroup/drug/detailsDrug";
import NewDrug from "../../components/leaderGroup/drug/newDrug";

export default function Drug({ data, notGroup }) {
  const [mode, setMode] = useState("table");
  console.log(mode);
  return (
    <Box>
      {mode === "table" && (
        <DetailsDrug notGroup={notGroup} mode={mode} setMode={setMode} />
      )}
      {mode === "new" && <NewDrug mode={mode} setMode={setMode} />}
    </Box>
  );
}
